__webpack_require__.hmrF = () => ("plans-page." + __webpack_require__.h() + ".hot-update.json");